import { combineReducers } from 'redux';

import createCertificateError from './createCertificateError';
import getCertificateStatusError from './getCertificateStatusError';

export default combineReducers({
  createCertificateError,
  getCertificateStatusError,
});
